module.exports = __webpack_public_path__ + "img/heshui.2c7d9caa.png";